import { buildLocalization, buildClassificationLocalization, StringUtil } from '@/util'
import { IDocumentDTO } from './IDocumentDTO'
import { IDocumentDisplayInfo } from './IDocumentDisplayInfo'

const electricDiagramDocTypes = ['EKI', 'EKO', 'ELB', 'ELD']

/** Helper class for converting documents to localized names to be displayed in the UI */
export class DocumentNames {
    // Documents
    private documents: IDocumentDTO[]
    private currentLanguage: string
    private localize: (id: string) => string
    private localizePropValueHierarchy: (propName: string, propValue?: string | null |  undefined) => string[]

    constructor(documents: IDocumentDTO[]) {
        this.documents = documents

        const { localize, currentLanguage } = buildLocalization();
        const { localizePropValueHierarchy } = buildClassificationLocalization();

        this.currentLanguage = currentLanguage.value
        this.localize = localize
        this.localizePropValueHierarchy = localizePropValueHierarchy
    }

    private docTypeLocalizationItem(docType: string): string {
        docType = docType.toUpperCase()

        return electricDiagramDocTypes.includes(docType)
            ? 'DocType_EXX'
            : `DocType_${docType}`
    }

    private getPropNameFor(docType: string): string | null {
        switch (docType) {
            case 'PID': return 'DM_PID_KATEGORI'
            case 'SPD': return 'DM_SPD_KATEGORI'
            case 'DOC': return 'DM_DOCUMENTATION_TYPE'
            default: return null;
        }
    }

    localizedNamesOfDocuments(): IDocumentDisplayInfo[] {
        const result: IDocumentDisplayInfo[] = []

        for (const doc of this.documents) {
            const propName = this.getPropNameFor(doc.documentType)

            // resx usage: localize('Doctype_PID') localize('Doctype_SPD') localize('Doctype_INS')
            //             localize('Doctype_DOC') localize('Doctype_EXX') localize('Doctype_SND')
            //             localize('Doctype_TDA') localize('Doctype_UMA')
            const localizedDocType = this.localize(this.docTypeLocalizationItem(doc.documentType))
            let localizedClassification: string | null = null
            let localizedDescription: string | null = null

            if (!StringUtil.isNullOrEmpty(doc.classification)) {
                localizedClassification = propName == null
                    ? `[${doc.classification}]`
                    : this.localizePropValueHierarchy(propName, doc.classification).join(' - ')
            }

            if (doc.shortTexts != null) {
                localizedDescription = doc.shortTexts[this.currentLanguage]?.text
                    ?? doc.shortTexts['E']?.text
                    ?? null
            }

            const docNames = {
                blobName: doc.blobName,
                localizedDocName: localizedClassification == null
                    ? localizedDocType
                    : `${localizedDocType} (${localizedClassification})`,
                localizedDescription: localizedDescription,
                visibility: doc.visibility,
                document: doc
            } as IDocumentDisplayInfo

            result.push(docNames)
        }

        return result.sortBy(d => d.localizedDocName)
    }
}
